import { render, staticRenderFns } from "./SettingsChecker.vue?vue&type=template&id=2e66c809"
import script from "./SettingsChecker.vue?vue&type=script&lang=js"
export * from "./SettingsChecker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports